import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AppActions} from '../../actions';
import {Document} from '../../../screens/profile/common/documents/model';

export interface DocumentsState {
  documents: Document[];
  dataLoading: boolean;
}

const initialState: DocumentsState = {
  documents: [],
  dataLoading: false,
};

export const documentsSlice = createSlice({
  name: '@@eskmo/agreements',
  initialState,
  reducers: {
    setDocuments: (state, {payload}: PayloadAction<Document[]>) => {
      state.documents = payload;
    },
    setDataLoading: (state, {payload}: PayloadAction<boolean>) => {
      state.dataLoading = payload;
    },
    reset: () => initialState,
  },
  extraReducers: {
    [AppActions.Reset]: () => initialState,
  },
});

export const documentsActions = documentsSlice.actions;

export const documents = documentsSlice.reducer;
